import React from 'react';
import { Switch } from '@components/ui/switch';
import { cn } from '@core/utils/cn';

interface RuleSetSectionProps {
    title: string;
    enabled: boolean;
    disabled?: boolean;
    toggleDisabled?: boolean;
    toggleTestId?: string;
    error?: boolean;
    onToggle?(enabled: boolean): void;
    children: React.ReactNode;
}

export const RuleSetSection = ({
    title,
    enabled,
    disabled,
    toggleDisabled,
    toggleTestId,
    error,
    onToggle,
    children
}: RuleSetSectionProps) => (
    <div
        className={cn(
            'rounded-lg border',
            error && 'border-destructive bg-destructive/5',
            disabled && 'opacity-60'
        )}
    >
        <div className="flex items-center justify-between px-4 py-3">
            <p className="text-sm font-semibold">{title}</p>
            <Switch
                checked={enabled}
                disabled={toggleDisabled ?? disabled}
                onCheckedChange={onToggle}
                data-testid={toggleTestId}
            />
        </div>
        {enabled && (
            <div className="flex flex-col gap-4 border-t px-4 py-4">
                {children}
            </div>
        )}
    </div>
);
